module.exports = __webpack_public_path__ + "img/image-2.45b98ae3.jpg";